<template>
    <form data-test-id="user-meeting-export-form" @submit.prevent="onMeetingsExport">
        <div class="tw-mb-5 tw-text-gray-400">{{ $t("profile.edit.exportCheckinsLabel") }}</div>
        <l-base-button type="submit" :button-types="['default', 'raised']">
            {{ $t("profile.edit.btnExport") }}
        </l-base-button>
    </form>
</template>

<script>
import api from "@/api";

import LBaseButton from "@/components/LBaseButton";

export default {
    components: {
        LBaseButton,
    },
    methods: {
        onMeetingsExport() {
            api.request({
                url: "/api/checkins/get/list/export/full",
                method: "GET",
                responseType: "blob",
            })
                .then(({ data }) => {
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([data], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        }),
                    );
                    const domLink = document.createElement("a");
                    domLink.classList.add("tw-hidden");
                    domLink.href = downloadUrl;
                    domLink.setAttribute(
                        "download",
                        `Meetings-Export-${new Date().toISOString().slice(0, 10)}.xlsx`,
                    );
                    document.body.appendChild(domLink);
                    domLink.click();
                    domLink.remove();
                })
                .catch(() => {
                    // ignore
                });
        },
    },
};
</script>
